import React from 'react'
import { Modal } from '@components/ui'

type MessageCenterDeleteCallLogModalProps = {
  show: boolean
  contactName: string
  onCancel: () => void
  onDelete: () => void
}

const MessageCenterDeleteCallLogModal: React.FC<
  MessageCenterDeleteCallLogModalProps
> = ({ show, contactName, onCancel, onDelete }) => {
  const name = contactName.trim() || 'this contact'

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      title="Delete call log"
      description={`Are you sure you want to delete ${name}'s call logs? This action can't be undone.`}
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      onPrimaryClick={() => {
        onDelete()
        onCancel()
      }}
      onSecondaryClick={onCancel}
    />
  )
}

export default MessageCenterDeleteCallLogModal
